import script from "./ChatBrandsTableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBrandsTableCard.vue?vue&type=script&setup=true&lang=js"

import "./ChatBrandsTableCard.vue?vue&type=style&index=0&id=026fa382&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026fa382"]])

export default __exports__